module.exports = __webpack_public_path__ + "static/media/plantOne.cc576a09.jpg";